import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { LookupItem } from "@data-types";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";

export default function OnboardingRegistrationTitle(props: {
	titleData: LookupItem[] | null;
}) {
	const { titleData } = props;

	const { t } = useTranslation("registration");

	if (titleData == null || titleData.length === 0) {
		return null;
	}

	return (
		<div className="form__field u-mar--bottom--reset">
			<label className="label label--strong">
				{t("TITLE_LABEL")}
				<RequiredMark required />
			</label>
			<ErrorMessage name="titleId" />

			<div className="row">
				{titleData
					?.reverse()
					.map((data) => (
						<RadioInput
							key={data.id}
							id={data.id}
							name="titleId"
							label={data.name}
							value={data.id}
							title={data.abrv}
						/>
					))}
			</div>
		</div>
	);
}

function RadioInput(props: {
	id: string;
	name: string;
	label: string;
	value: string;
	title: string;
}) {
	const { id, name, label, value, title } = props;

	const { t } = useTranslation();
	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	const inputWrapperClasses = classNames("input--radio input--title", [
		`input--${title}`,
	]);

	const inputBoxClasses = classNames("input--radio__box input--title__box", [
		`input--${title}__box`,
	]);

	const inputLabelClasses = classNames(
		"input--radio__label input--title__label",
		[`input--${title}__label`]
	);

	return (
		<div className="col col-sml-6">
			<div className={inputWrapperClasses}>
				<input
					id={id}
					className={inputBoxClasses}
					type="radio"
					value={value}
					{...field}
				/>
				<label htmlFor={id} className={inputLabelClasses}>
					{t(label)}
				</label>
			</div>
		</div>
	);
}
